<template>
  <div class="chart-block mb-5 px-3">
	<div class="row">
		<div class="col-12 col-md-8">
			<h2 v-if="ordinaryDisplay" class="font-weight-bold">{{ chart.title }}</h2>
        	<h2 v-if="noTownValue" class="font-weight-bold">（{{ location.countyname }}之）{{ chart.title }}</h2>
		</div>
		<div class="col-12 col-md-4">
			<button class="ts-btn h6" @click="downloadData" v-if="!showTileImage">
				<img :src="downloadPng"	/> 下載資料(.CSV)
			</button>
			<button class="ts-btn h6" @click="sendDataForInsight" :disabled="isAIProcessing" v-if="showAIButton">
				<img :src="aiPng" /> AI 闡釋
			</button>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<h1 v-if="showTilelistTitle(chart.id)"><img :src="mapPng" class="add-btn" />：看疊圖　<img :src="removePng" class="add-btn" />：清除疊圖</h1>
		<h2 v-if="showTileImage">－{{ chart.title }}
			<img :src="mapPng" class="add-btn" v-if="notOnlyOptUnsel" @click="showTile()"/>
			<img :src="removePng" class="add-btn" v-if="group0.length != 0"  @click="removeTiles()"/>
			<h5 class="tilelist" v-if="showTileImage" v-for="(column) in chart.columns">
				<input v-if="chart.columns.length > 1" :id="chart.id" type="checkbox" v-model="group" :value="column" />
				<label v-if="chart.columns.length > 1">{{ getTitle(column) }}</label>
				<span v-if="chart.columns.length == 1">&thinsp;■&ensp;{{ getTitle(column) }}</span>
			</h5>
		</h2>
        <img class="chart-table-btn" :src="chartIcon" alt="圖表"
          @mouseenter="chartIconHover = true" @mouseout="chartIconHover = false"
          @click="showChart = true" v-if="showButton">
        <img class="chart-table-btn" :src="tableIcon" alt="表格"
          @mouseenter="tableIconHover = true" @mouseout="tableIconHover = false"
          @click="showChart = false" v-if="showButton">
		<p class="instruction" v-if="showAdminComparison && !showTableOrTypeTable" style="display:inline-block"><u>點選圖例：鄉鎮對比縣市/全國資料</u></p>
		<p class="instruction" v-if="showAdminComparison" style="display:inline-block">；</p>
		<p class="instruction" v-if="showMapInstruction" style="display:inline-block"><u>點選圖表資料：看地圖</u></p>
        <p class="instruction" v-if="showTableOrTypeTable" style="display:inline-block"><u>點選<img :src="mapPng" class="add-btn" />：看地圖</u></p>
		<p class="instruction" v-if="showTableOrTypeTable && applyUserData" style="display:inline-block">；</p>
		<p class="instruction" v-if="showTableOrTypeTable && applyUserData" style="display:inline-block"><u>點選<img :src="addPng" class="add-btn" />：新增資料</u></p>
		</div>
	</div>
    <!-- <header>
      <div class="h-left">
        <h1 v-if="ordinaryDisplay">{{ chart.title }}</h1>
        <h1 v-if="noTownValue">（{{ location.countyname }}之）{{ chart.title }}</h1>
		<h1 v-if="showTilelistTitle(chart.id)"><img :src="mapPng" class="add-btn" />：看疊圖　<img :src="removePng" class="add-btn" />：清除疊圖</h1>
		<h2 v-if="showTileImage">－{{ chart.title }}
			<img :src="mapPng" class="add-btn" v-if="notOnlyOptUnsel" @click="showTile()"/>
			<img :src="removePng" class="add-btn" v-if="group0.length != 0"  @click="removeTiles()"/>
			<h5 class="tilelist" v-if="showTileImage" v-for="(column) in chart.columns">
				<input v-if="chart.columns.length > 1" :id="chart.id" type="checkbox" v-model="group" :value="column" />
				<label v-if="chart.columns.length > 1">{{ getTitle(column) }}</label>
				<span v-if="chart.columns.length == 1">&thinsp;■&ensp;{{ getTitle(column) }}</span>
			</h5>
		</h2>
        <img class="chart-table-btn" :src="chartIcon" alt="圖表"
          @mouseenter="chartIconHover = true" @mouseout="chartIconHover = false"
          @click="showChart = true" v-if="showButton">
        <img class="chart-table-btn" :src="tableIcon" alt="表格"
          @mouseenter="tableIconHover = true" @mouseout="tableIconHover = false"
          @click="showChart = false" v-if="showButton">
        <p class="instruction" v-if="showTableOrTypeTable">點選<img :src="mapPng" class="add-btn" />：看地圖</p>
		<p class="instruction" v-if="showMapInstruction">點選圖表資料：看地圖</p>
      </div>
	  <div class="h-right">
		<button class="ts-btn" @click="downloadData" v-if="!showTileImage">
			<img :src="downloadPng"	/> 下載資料(.CSV)
		</button>
	  </div>
    </header> -->

    <template v-if="showChart">
      <LineChart
        v-if="chart.type === 'line_chart'"
        :index="index"
        :chartdata="lineChartData"
        :chartcolumns="tableColumns"
        :categ="categ"
        :subcateg="subcateg"
        :location="this.location"
        :userColumnsData="userColumnsData"
      />
      <PieChart
        v-else-if="chart.type === 'pie_chart'"
        :chartdata="chartdata"
        :chartcolumns="tableColumns"
        :years="years"
        :categ="categ"
        :subcateg="subcateg"
		:userColumnsData="userColumnsData"
      />
      <TreemapChart
        v-else-if="chart.type === 'treemap_chart'"
        :chartdata="chartdata"
      />
      <ColumnChart
        v-else-if="chart.type === 'bar_chart'"
        :chartdata="chartdata"
        :chartcolumns="tableColumns"
        :years="years"
        :categ="categ"
        :subcateg="subcateg"
        :userColumnsData="userColumnsData"
      />
      <GroupColumnChart
        v-else-if="chart.type === 'grp_bar_chart'"
        :chartdata="groupColumnChartdata"
        :chartcolumns="tableColumns"
        :years="years"
        :categ="categ"
        :subcateg="subcateg"
      />
      <PopulationPyramid
        v-else-if="chart.type === 'pop_pyramid'"
        :chartdata="popPyramidChartdata"
        :chartcolumns="tableColumns"
        :years="years"
        :categ="categ"
        :subcateg="subcateg"
      />
    </template>
    <div class="table-chart" v-if="showTableOrTypeTable">
      <TesasTable
        :tableColumns="tableColumns"
        :tableColumnsTitle="tableColumnsTitle"
		:columnClickables="columnClickables"
        :years="years"
        :categ="categ"
        :subcateg="subcateg"
        :location="this.location"
        :tableData="tableData"
        :applyUserData="applyUserData"
		:userColumnsData="userColumnsData"
        @user-columns-changed="handleUserColumnsChanged"
      />
    </div>
  </div>
</template>

<script>
import chartIconPressedPng from "../../assets/images/btn-indicators-graphic-hover-press.png"
import chartIconNormalPng from "../../assets/images/btn-indicators-graphic-normal.png"
import tableIconPressedPng from "../../assets/images/btn-indicators-data-hover-press.png"
import tableIconNormalPng from "../../assets/images/btn-indicators-data-normal.png"
import mapPng from "../../assets/images/6-analysis/map.png"
import addPng from "../../assets/images/6-analysis/add.png"
import removePng from "../../assets/images/6-analysis/remove.png"
import LineChart from '../charts/line-chart.vue'
import TreemapChart from "../charts/treemap-chart.vue"
import PieChart from "../charts/pie-chart.vue"
import ColumnChart from "../charts/column-chart.vue"
import GroupColumnChart from "../charts/group-column-chart.vue"
import PopulationPyramid from "../charts/pop-pyramid.vue"
import TesasTable from "../charts/tesas-table.vue"
import downloadPng from "../../assets/images/6-analysis/download.png";
import aiPng from "../../assets/images/6-analysis/ai.png";

const API_BASE_PATH = window.location.hostname === 'localhost' 
    ? 'http://localhost:3003/tesas_ai' 
    : '/tesas_ai';
	
export default {
  props: [
    "index",
    "chart",
    "location",
    "columnsTitle",
    "years",
    "temporalData",
    "categ",
    "subcateg",
	"wmtslist"
  ],
  components: { LineChart, TreemapChart, PieChart, ColumnChart,
                GroupColumnChart, PopulationPyramid, TesasTable },
  data() {
    return {
      showChart: true,
      chartIconHover: false,
      tableIconHover: false,
      mapPng,
	  addPng,
	  aiPng,
	  removePng,
	  group:  [],
	  group0: [],
	  downloadPng,
	  userColumnsData: [],
      isAIProcessing: false,
	  showAIButton: false,  //the hide/show AI button status
	  aiModel: null
    }
  },
  mounted(){
    //console.log(this.chart);
	//console.log('adminscl from chart-block: '+this.location.type);
	const aiParam = this.$route.query.ai ? this.$route.query.ai.toLowerCase() : null;
    if (aiParam === '1b' || aiParam === '4b' || aiParam === '12b') {
      this.showAIButton = true;
      this.aiModel = aiParam;
      console.log(`AI feature enabled with ${aiParam} model`);
    } else if (aiParam === 'true') {
      this.showAIButton = true;
      this.aiModel = '1b';  // Default to 1b
      console.log('AI feature enabled with default 1b model');
    };
	
	if (this.chart.type === 'wmts'){
		if (this.group.length == 0 && this.group0.length == 0 && this.wmtslist.length != 0){
			this.chart.columns.forEach((column) => {
				if (column == this.wmtslist || column in this.wmtslist){
					this.group.push(column)
					this.group0.push(column)
				}
			})
		}else{
			this.group = [];
			this.group0 = [];
		}
	}
  },
  methods: {
	allNull(){
	  var dataallnull = true;
	  if (this.chart.type === 'line_chart'){
		dataallnull = false
	  }else if(this.chart.type === 'grp_bar_chart'){
        this.chart.columns.forEach((column) => {
	      this.chart.suffixes.forEach((s) => {
		    //console.log(this.temporalData[this.years.length-1][column + s])
		    if (this.temporalData[this.years.length-1][column + s] !== null){
		  	dataallnull = false
		    }
		  })
	    })
	  }else{
        this.chart.columns.forEach((column) => {
		  if (this.temporalData[this.years.length-1][column] !== null){
		    dataallnull = false
		  }
	    })
	  }

	  return dataallnull
	},
    //gChartdata(column) {
	//  if (!this.allNull()){
    //    let data = [['Year', column.title]]
    //    this.temporaldata.map((d, index) => {
	//		//console.log(d);
	//		data.push([this.years[index], parseFloat(d[column.column])])
    //    })
	//	//console.log('Ln216: '+data);
	//	return data
	//  }else{
	//    let datacounty = [['Year', column.title]]
	//	this.temporaldata.map((d, index) => {
	//		//console.log(d);
	//		datacounty.push([this.years[index], parseFloat(d[column.column])])
	//	})
	//	//console.log('Ln224: '+data);
	//	return datacounty
	//  }
    //},
	showTile(){
	  if (this.chart.columns.length == 1) {this.group = this.chart.columns[0]}
	  this.group0 = this.group;
	  this.$root.$emit('refresh_grouplist',{chartid:this.chart.id, grouplist:this.group});
	  this.$root.$emit('retract_panel')
	},
	showTilelistTitle(chartid){
		return (this.chart.type === 'wmts' || this.chart.type === 'wms')&&(chartid == this.subcateg.charts[0].id)
	},
	removeTiles(){
		this.group = [];
		this.group0 = [];
		this.$root.$emit('refresh_grouplist',{chartid:this.chart.id, grouplist:this.group})
	},
	getTitle(column){
		//console.log(column)
		//console.log(this.chart.columns.length)
		//console.log(this.subcateg.columns.filter(x => x.id == column)[0])
		return this.subcateg.columns.filter(x => x.id == column)[0].title;
	},
	download(filename, blob) {
	
		var link = document.createElement("a");
		if (navigator.msSaveOrOpenBlob) { // IE 10+
			link.addEventListener("click", function (event) {
				navigator.msSaveOrOpenBlob(blob, filename);
			}, false);
		}else if (link.download !== undefined) { // feature detection
			// Browsers that support HTML5 download attribute
			var url = window.URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", filename);
			link.style = "visibility:hidden";
		}
		
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},
    // Shared function to compile table data
    compileTableData() {
        var tableRows = [];
        
        // Calculate total columns (original + user columns)
        const userColumnCount = this.userColumnsData.length;
        const totalColumns = this.tableColumns.length + userColumnCount + 1; // +1 for year column
        
        // Create header row
        var headerRow = new Array(totalColumns);
        headerRow[0] = "年份";
        
        // Add original table columns
        this.tableColumns.forEach((column, icol) => {
            headerRow[icol + 1] = this.tableColumnsTitle[column];
        });
        
        // Add user data column headers
        this.userColumnsData.forEach((userColumn, icol) => {
            headerRow[this.tableColumns.length + icol + 1] = userColumn.title || `使用者資料${icol + 1}`;
        });
        
        tableRows.push(headerRow);
        
        // Create data rows
        this.years.forEach((year, iyear) => {
            var row = new Array(totalColumns);
            row[0] = year;
            
            // Add original table data
            this.tableColumns.forEach((column, icol) => {
                row[icol + 1] = this.tableData[iyear][column];
            });
            
            // Add user data values (indexed by year index)
            this.userColumnsData.forEach((userColumn, icol) => {
                const userValue = userColumn.data && userColumn.data[iyear] !== undefined 
                    ? userColumn.data[iyear] 
                    : '';
                row[this.tableColumns.length + icol + 1] = userValue;
            });
            
            tableRows.push(row);
        });
        
        return tableRows;
    },
    
    // function for data download
    downloadData() {
        const tableRows = this.compileTableData();
        
        console.log(tableRows);
        var blob = new Blob([iconv.encode(tableRows.join('\r\n'), 'big5').filter(function(el){return el != 0;})],
                                {type : 'application/csv'});
        this.download(this.tableName + '.csv', blob);
    },
    // send data to the backend for AI insight
	async sendDataForInsight() {
		try {
			this.isAIProcessing = true;
			
			const tableRows = this.compileTableData();
			const csvText = tableRows.map(row => row.join(',')).join('。');
			
			// Full prompt for AI (kept intact)
			const fullPrompt = `請根據下述資料的資料集名稱「${this.tableName}」、欄位名稱並觀察各欄位資料趨勢後，針對以下三項需求簡要的進行分析與說明：1.關鍵資料趨勢2.趨勢的成因3.地方創生建議，除此之外不要做其他分析。務必從欄位名稱判斷其所指地點或行政層級：除非欄位名稱未包含地點/地區/行政層級名稱者，將其地點/地區假設為資料集名稱所包含的地點/地區名稱。回答時若欄位名稱表示資料中有不同年度的變化、或是不同地點/地區/行政層級的資料，也務必進行比較分析。切記不要把逐年下降趨勢分析為上升趨勢或是將地點/地區之間數量大小比較出錯。如果有「年份」欄位，切記其指的是**民國年**，與西元年、月份、或季節都無關。回答時**請省略「好的」等起始用語，直接用「以下是」開頭即可**。以下資料以句點「。」區分各列，第一列為欄位名稱，後續各列的數值按其順序對應到第一列的各欄位而成為其資料內容：\n${csvText}`;
			//`請根據下述資料的資料集名稱「${this.tableName}」、欄位名稱並綜合其資料內容，針對這三項需求簡要的進行分析與說明：1.關鍵資料趨勢2.趨勢的成因3.地方創生建議，除此之外不要做其他分析。如果有「年份」欄位，指的是**民國年**。回答時**請省略「好的」等起始用語，直接用「以下是」開頭即可**。\n${csvText}`;
			//`請根據下述資料的資料集名稱「${this.tableName}」及欄位名稱進行資料分析並提供重點闡釋、可能的原因分析和建議。欄位名稱未標註地點者可由資料集名稱得知該欄位是屬於哪個地點的資料。回答時若有不同年度的變化、不同行政層級的比較或跨區的比較，也請進行分析，但請簡要說明。請省略「好的」等起始用語，直接用「以下是」開頭即可。\n${csvText}`;
			
			// Create display version with table HTML
			const displayMessage = this.formatTableForDisplay(tableRows);
			
			const sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
			
			console.log('Vue: Generated session ID:', sessionId);
			console.log('Vue: Using AI model:', this.aiModel);
			console.log('Vue: Storing message on server...');
			
			// Store on server temporarily with both versions
			const response = await fetch(`${API_BASE_PATH}/api/store-message`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ 
					sessionId, 
					message: fullPrompt,  // Full prompt for AI
					displayMessage: displayMessage,  // Formatted version for user display
					model: this.aiModel
				})
			});
			
			if (!response.ok) {
				throw new Error('Failed to store message on server');
			}
			
			console.log('Vue: Message stored successfully');
			
			// Open with just session ID
			const url = `${API_BASE_PATH}?session=${sessionId}&model=${this.aiModel}`;
			console.log('Vue: Opening URL:', url);
			window.open(url, '_blank');
			
		} catch (error) {
			console.error('Error preparing data:', error);
			alert(`無法準備資料: ${error.message}`);
		} finally {
			this.isAIProcessing = false;
		}
	},
	
	// Format data table for display
	formatTableForDisplay(tableRows) {
		if (tableRows.length === 0) return '';
		
		// Create HTML table
		let html = '<p>將以下資料以 AI 闡釋功能進行分析：</p>';
		html += `<h3 style="margin: 15px 0 10px 0; font-weight: bold; color: #333;">${this.escapeHtml(this.tableName)}</h3>`;
		html += '<table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; margin-top: 10px;">';		
		
		// Header row
		html += '<thead><tr style="background-color: #f0f0f0;">';
		tableRows[0].forEach(header => {
			html += `<th style="padding: 8px; text-align: left; font-weight: bold;">${this.escapeHtml(header)}</th>`;
		});
		html += '</tr></thead>';
		
		// Data rows
		html += '<tbody>';
		for (let i = 1; i < tableRows.length; i++) {
			html += '<tr>';
			tableRows[i].forEach((cell, index) => {
				const cellValue = cell !== null && cell !== undefined ? cell : '';
				const align = index === 0 ? 'left' : 'right';  // Year column left, data columns right
				html += `<td style="padding: 8px; text-align: ${align};">${this.escapeHtml(String(cellValue))}</td>`;
			});
			html += '</tr>';
		}
		html += '</tbody></table>';
		
		return html;
	},
	
	// Helper method to escape HTML
	escapeHtml(text) {
		const map = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#039;'
		};
		return text.replace(/[&<>"']/g, m => map[m]);
	},
	handleUserColumnsChanged(userColumns) {
	  this.userColumnsData = userColumns;
	}
  },
  computed: {
	ordinaryDisplay: function () {
		//console.log(this.allNull(), this.chart.type)
		return ((this.subcateg.minscl != 'county' || this.location.type == 'county') && !this.allNull() && !this.showTileImage);
	},
	noTownValue: function () {
		return (((this.subcateg.minscl == 'county' && this.location.type != 'county') || this.allNull()) && !this.showTileImage);
	},
	applyUserData(){
		return this.chart.userdata
	},
	showTableOrTypeTable(){
		return ((!this.showChart || this.chart.type === 'table') && !this.showTileImage);
	},
	showTileImage(){
		return this.chart.type === 'wmts' || this.chart.type === 'wms';
	},
	notOnlyOptUnsel(){
		return ((this.chart.columns.length == 1 && this.chart.columns[0] != this.group0) || (this.chart.columns.length != 1))
	},
	showButton(){
		return this.chart.type !== 'table' && !this.showTileImage;
	},
	showMapInstruction(){
		return !this.showTileImage && !this.showTableOrTypeTable;
	},
	showAdminComparison(){
		return this.chart.admnlvcmp && this.location.type == 'town'
	},
    chartIcon() {
      if(this.showChart || this.chartIconHover)
        return chartIconPressedPng
	  else
        return chartIconNormalPng
    },
    tableIcon() {
      if(!this.showChart || this.tableIconHover)
        return tableIconPressedPng
      else
        return tableIconNormalPng
    },
    hrefURL() {
      let path = `./index_selection.html`
      return path
    },
    lineChartData() {
      let data = {
        labels: this.years,
        datasets: []
      };
	  if(this.chart.admnlvcmp && this.chart.admnlvcmp == true){
		data.admnlvcmp = true
	  }else{
		this.chart.admnlvcmp = false;
		data.admnlvcmp = false
	  }
      this.chart.columns.forEach((column) => {
        data.datasets.push({
          label: this.columnsTitle[column],
          tesasColumn: column,
          data: this.years.map((y, i) => this.temporalData[i][column])
        });
		if(this.chart.admnlvcmp == true && this.location.type == 'town'){
			data.datasets.push({
				label: this.columnsTitle[column]+'-'+this.location.countyname,
				tesasColumn: column+'-county',
				data: this.years.map((y, i) => this.temporalData[i].county[column])
			});
			this.years.map((y, i) => {this.temporalData[i][column+"_county"] = this.temporalData[i].county[column]})
			data.datasets.push({
				label: this.columnsTitle[column]+'-全國',
				tesasColumn: column+'-nation',
				data: this.years.map((y, i) => this.temporalData[i].nation[column])
			});
			this.years.map((y, i) => {this.temporalData[i][column+"_nation"] = this.temporalData[i].nation[column]})
			//console.log(this.temporalData)
		};
      })
	  //console.log(this.chart);
      //console.log(data);
      return data
    },
    chartdata() {
      let data = []

      this.chart.columns.forEach((column) => {
		if (!this.allNull()){
			data.push([this.columnsTitle[column], this.temporalData[this.years.length-1][column]])
		}else{
			data.push([this.columnsTitle[column], this.temporalData[this.years.length-1].county[column]])
		}
      })

      return data
    },
    groupColumnChartdata() {
      let data = []
      data.push(["Labels"].concat(this.chart.grp_title))

      this.chart.columns.forEach((column) => {
		//console.log(this.temporalData[this.years.length-1])
		//console.log(column,this.chart.suffixes[0])
		//console.log(this.allNull());
        let row = [this.columnsTitle[column + this.chart.suffixes[0]]]
        this.chart.suffixes.forEach((s) => {
		  if (!this.allNull()){
			row.push(this.temporalData[this.years.length-1][column + s])
		  }else{
			row.push(this.temporalData[this.years.length-1].county[column + s])
		  }
        })

        data.push(row)
      })

      return data
    },
    popPyramidChartdata() {
      let data = new Array(this.chart.columns.length+1)
      data[0]=(["年齡層"].concat(this.chart.grp_title))

      this.chart.columns.forEach((column,icol) => {
        let row = [this.columnsTitle[column + this.chart.suffixes[0]]]
        this.chart.suffixes.forEach((s) => {
		  if (!this.allNull()){
			if (s=='_m_cnt'){
				row.push(-this.temporalData[this.years.length-1][column + s])
			}else{
				row.push(this.temporalData[this.years.length-1][column + s])
			}
		  }else{
			if (s=='_m_cnt'){
				row.push(-this.temporalData[this.years.length-1].county[column + s])
			}else{
				row.push(this.temporalData[this.years.length-1].county[column + s])
			}
		  }
        })

        data[this.chart.columns.length-icol]=row;
      })
      return data
    },
	tableName(){
		if (this.ordinaryDisplay){
			return this.location.name+'之'+this.chart.title;
		}else{
			return this.location.countyname+'之'+this.chart.title;
		}
	},
	tableColumns(){
	  var ccols = [];
	  if (this.chart.type === 'line_chart'){
	    //console.log(this.chart.columns);
		//console.log(this.chart.admnlvcmp);
		if (this.chart.admnlvcmp){
			this.chart.columns.forEach((column)=>{
				ccols.push(column)
				if (this.location.type === 'town') {
					ccols.push(column+'_nation')
					ccols.push(column+'_county')
				}
			})
		}else{
			ccols = this.chart.columns;
		}
	  }else if(this.chart.type === 'grp_bar_chart' || this.chart.type === 'pop_pyramid'){
        this.chart.columns.forEach((column) => {
	      this.chart.suffixes.forEach((s) => {
			ccols.push(column + s)
		  })
	    })
	  }else{
		ccols = this.chart.columns;
	  }
		//console.log(ccols)
	  return ccols
	},
	columnClickables(){
		var clickables = {}
		this.tableColumns.forEach((tcol)=>{
			if (tcol.substring(tcol.length - 7) != '_nation' &&
				tcol.substring(tcol.length - 7) != '_county'){
				clickables[tcol] = true
			}else{
				clickables[tcol] = false
			}
		})
		//console.log(clickables);
		return clickables
	},
	tableColumnsTitle(){
	  var colstitle = {};
	  if (this.chart.type === 'line_chart'){
		if (this.chart.admnlvcmp){
			this.chart.columns.forEach((column) => {
				this.columnsTitle[column+"_county"] = this.columnsTitle[column]+'-'+this.location.countyname
				this.columnsTitle[column+"_nation"] = this.columnsTitle[column]+'-全國'
			})
		}
	    //console.log(this.columnsTitle)
		colstitle = this.columnsTitle;
	  }else if(this.chart.type === 'grp_bar_chart' || this.chart.type === 'pop_pyramid'){
        this.chart.columns.forEach((column) => {
	      this.chart.suffixes.forEach((s,isuf) => {
			colstitle[column + s] = this.columnsTitle[column + s]+'（'+this.chart.grp_title[isuf]+'）'
		  })
	    })
	  }else{
		colstitle = this.columnsTitle;
	  }

	  //console.log(colstitle)
	  return colstitle
	},
	tableData(){
		//console.log(this.temporalData)
		if (!this.allNull()){
			//console.log(this.temporalData)
			return this.temporalData
		}else{
			return [this.temporalData[this.years.length-1].county]
		}
	},
    legendContainerId() {
      return "legendContainer_" + this.index
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../../css/custom_var";
@import "../../css/custom_mixin";

.chart-block {
  margin-bottom: 20px;
}

header {
  display: flex;
  justify-content: space-between;

  .ts-btn {
    font-size: 1.1rem;
	font-family: Helvetica, "微軟正黑體", Arial, sans-serif;
	height: 40px;
    width: 170px;
  }
  .tilelist {
    padding-left: 20px;
  }
}

.ts-btn {
	width: 150px;
	height: 30px;
}

.ts-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.instruction {
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.add-btn {
  width: 20px;
  height: 20px;
  margin: 0 5px;
}

.table-chart {
  width: 100%;
  overflow-x: auto;
}

.chart-table-btn {
  width: 25px;
  height: 25px;
}
</style>
